export enum NotificationType {
  RealTime = 'RealTime',
  FeedNotification = 'Feed'
}
